/** spacing styles names */
export const SPACING_NAMES = {
  DEFAULT: 'default',
};

/** spacing styles */
export const SPACING = {
  [SPACING_NAMES.DEFAULT]: '48px',
};
